export const environment = {
  production: true,
  server: "aws", // This will be overwritten by the script during build time

  eth: {
    chainId: '0x1', //hexadecimal for metamask
    chainIdInt: 1,
    chainName: 'Ethereum Mainnet',
    gasFees: 0.005,
    purchaseToken: 'ETH',
    hasStaking: true,
    nativeFunction: 'buyWithEth',
    presaleAddress: '0x800480C9a985Ca38A41BD343859818223775C671',
    multicall: '0xca11bde05977b3631167028862be2a173976ca11',
    usdTAddress: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    usdcAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    rpcURL: 'https://proportionate-small-fire.quiknode.pro/d78da87132bf57ace50b7592b60fa1ef3818c8c8',
    backupRPC: 'https://proportionate-small-fire.quiknode.pro/d78da87132bf57ace50b7592b60fa1ef3818c8c8',
    blockExplorerURL: 'https://etherscan.io/tx/',
    chainInfo: {
      method: 'wallet_addEthereumChain',
      params: [
        {
          chainId: '0x1',
          chainName: 'Ethereum Mainnet',
          nativeCurrency: {
            name: 'ETH',
            symbol: 'ETH',
            decimals: 18,
          },
          rpcUrls: ['https://rpc.ankr.com/eth'],
          blockExplorerUrls: ['https://etherscan.io/'],
        },
      ],
    },
  },

  bsc: {
    chainId: '0x38', //hexadecimal for metamask
    chainIdInt: 56,
    chainName: 'BSC Mainnet',
    gasFees: 0.0025,
    purchaseToken: 'BNB',
    hasStaking: false,
    nativeFunction: 'buyWithBNB',
    multicall: '0xca11bde05977b3631167028862be2a173976ca11',
    presaleAddress: '0x0a84d463f12ae0deff7df10bdfe3ffb505adc933',
    usdTAddress: '0x55d398326f99059fF775485246999027B3197955',
    usdcAddress: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
    rpcURL: 'https://proportionate-small-fire.bsc.quiknode.pro/d78da87132bf57ace50b7592b60fa1ef3818c8c8',
    backupRPC: 'https://proportionate-small-fire.bsc.quiknode.pro/d78da87132bf57ace50b7592b60fa1ef3818c8c8',
    blockExplorerURL: 'https://bscscan.com/tx/',
    chainInfo: {
      method: 'wallet_addEthereumChain',
      params: [
        {
          chainId: '0x38',
          chainName: 'BSC Mainnet',
          nativeCurrency: {
            name: 'BNB',
            symbol: 'BNB',
            decimals: 18,
          },
          rpcUrls: ['https://bsc-dataseed.binance.org'],
          blockExplorerUrls: ['https://bscscan.com/'],
        },
      ],
    },
  },
  polygon: {
    chainIdInt: 137,
    chainName: 'Polygon',
    gasFees: 0,
    purchaseToken: "MATIC",
    hasStaking: false,
    nativeFunction: "buyWithMATIC",
    rpcURL: 'https://proportionate-small-fire.matic.quiknode.pro/d78da87132bf57ace50b7592b60fa1ef3818c8c8',
    backupRPC: 'https://proportionate-small-fire.matic.quiknode.pro/d78da87132bf57ace50b7592b60fa1ef3818c8c8',
    blockExplorerUrl: 'https://polygonscan.com/',
    multicall: '0xca11bde05977b3631167028862be2a173976ca11',
    presaleAddress: '0x0a84D463f12AE0DefF7df10bDFE3fFB505ADc933',
    usdTAddress: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
    usdcAddress: '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
  },
  arbitrum: {
    chainIdInt: 42161,
    chainName: 'Arbitrum',
    nativeFunction: "buyWithEth",
    gasFees: 0,
    rpcURL: 'https://proportionate-small-fire.arbitrum-mainnet.quiknode.pro/d78da87132bf57ace50b7592b60fa1ef3818c8c8',
    backupRPC: 'https://proportionate-small-fire.arbitrum-mainnet.quiknode.pro/d78da87132bf57ace50b7592b60fa1ef3818c8c8',
    blockExplorerUrl: 'https://arbiscan.io/',
    multicall: '0xca11bde05977b3631167028862be2a173976ca11',
    presaleAddress: '0x0a84d463f12ae0deff7df10bdfe3ffb505adc933',
    usdTAddress: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
    usdcAddress: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
    arbAddress: '0x912CE59144191C1204E64559FE8253a0e49E6548',
    hasStaking: false,
    purchaseToken: 'ARB',
  },
  sol: {
    chainIdInt: 101,
    usdcTokenAddress: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
    usdtTokenAddress: 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
    presaleAddress: 'SEEr51D5UJyCP9seYK3s535BKt54E8NJRTpvaHk7WWW',
    SolRpcUrl: 'https://proportionate-small-fire.solana-mainnet.quiknode.pro/d78da87132bf57ace50b7592b60fa1ef3818c8c8',
    SolBackupRpcUrl: 'https://proportionate-small-fire.solana-mainnet.quiknode.pro/d78da87132bf57ace50b7592b60fa1ef3818c8c8',
    otherAccountUsdc: 'FcvRuyqwiTFXJ5LxQJ37wKTj2MpHv6J4gN2gbw6DVs9N', // USDC TOKEN ACCOUNT ADDRESS - USER LEVEL
    otherAccountUsdt: 'HS4ZSDMwKyK3fnf7UJxdqQ8ocvj6HQsgJNkFUUTq14eH', // USDT TOKEN ACCOUNT ADDRESS - USER LEVEL
    otherAccountSol: 'ARtMDVEepkDTMPHFA8nTa9H9MJcc9EApNaXjm2Y37VEs', // WALLET ADDRESS
    chainlinkFeed: 'CH31Xns5z3M1cTAbKW34jcxPPciazARpijcHj9rxtemt', // USED TO FETCH SOL CURRENT PRIZE, THIS VARIOUS ACCORDING TO TOKEN
    chainlinkProgram: '7UVimffxr9ow1uXYxsr4LHAcV58mLzhmwaeKvJ1pjLiE', // USED FOR CHAIN LINK FEED, REMAINS SAME FOR ALL TOKENS
    gasFees: 0.0001,
    blockExplorerURL: 'https://solscan.io/tx/',
    purchaseToken: 'SOL',
    nativeFunction: 'buyToken',
    hasStaking: false,
  },

  minToken: 10,
  stakingAddress: '0xBBF1715d5Bb85385CB58Dc1ebA95e49935801E9B',
  apyCalcConst: 400000000,
  stakeUnlockTime: 0,   // add 7 days epoch time in milliseconds with the claim activation time
  robots: "noindex",
  tokenName: '$SEERX',
  iidDashFx: 0,
  urlDashFx_aws: '',
  urlDashFx_firebase: '',
  urlDashFx_cloudfront: '',
  wertOrigin: 'https://widget.wert.io', // mainnet
  partnerId: '01KRP4PK2ZTHG8WXD9KPFKN3H7', // mainnet
  wertUrl: 'https://wert-signer.weathered-tooth-7cf8.workers.dev', // mainnet
  referUrl: '',
  bwUniversalLink: 'https://best-wallet-prod.web.app',
  bwDeepLink: 'bw://app/connect?',
  bwApiUrl: 'https://core.bestwallet.com/webhook-service-api/presale',
  showBestWallet: false,
  domain: 'https://seerdex.com', // replace with live site URL [NO SLASH IN THE END]
  sseUrl: 'https://backend.web3paymentsolutions.io/v1/api/sse-by-slug?slug=SEERX&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzbHVnIjoiU0VFUlgiLCJpYXQiOjE3ODEwMDMxNTN9.9nz2Dznr7Se1axPiegpGDCE81u0uzqQvhxaWYwBAB44',
  notificationTimeout: 7000,
  presaleName: 'Seerdex',
  presale_singular_link: 'https://best.sng.link/Dnio2/16gi?_smtype=3',
  post_presale_singular_link: '',
  wertOnRampUrl: 'https://wert-onramp.weathered-tooth-7cf8.workers.dev', //will change according to the presales.
  twitterId: '', // twitter handler id. i.e. '@abc_TWIT',
  reownProductId: '664dac7018a3dcca6b8747c07948ff09',
  isVwoEnabled: false,
  isClaimEnabled: false,// need to set it true when claim is live
  solGasAddress: 'hPYrKQ3jxdr8VRqFAf6va5pU67RFStsbn7i6yviFWD6', // SOL GAS WALLET ADDRESS
  wertSigner: 'CYdZAb4i2oaz5CiAvwenMyUVm2DJdd2cWKsekKxxXCQX',
  crmPixelApiKey: "hWlOfPZVZ6ayFJeQZOFTo5fDHu9SEZsO3Y1SLFNB",//add api key here, will be provided by the crm team
  crmPixelUrl: "https://d33uymcnkt4mry.cloudfront.net/",
  slug: 'SEERX',
  pixelEnv: "production",
  crmPixelEventsApiUrl: "https://d9a5yju4g02c5.cloudfront.net/events",
  gasAddress: '0x0000000000000000000000000000000000000001',
  transactionUrl: "https://dtxw9xix4exl0.cloudfront.net/presale-analytics-service/v1/api/transactions/SEERX?count=10&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzbHVnIjoiU0VFUlgiLCJpYXQiOjE3ODA5ODU5NjF9.PsIfXxkbRdqcEw4hz9OlR-DccJMDljm6RjTbOCcFHoo",
  PUBLIC_ETH_ROUTER_ADDRESS_v2: '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D',
  PUBLIC_ETH_ROUTER_ADDRESS_v3: '0x61fFE014bA17989E743c5F6cB21bF9697530B21e',
  PUBLIC_BSC_ROUTER_ADDRESS_v2: '0x10ED43C718714eb63d5aA57B78B54704E256024E',
  PUBLIC_BSC_ROUTER_ADDRESS_v3: '0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997',
  sendGTAGData: true, // set it false to stop sending data to gtag
};


/*
//devnet
export const environment = {
  production: false,
  server: "aws", // This will be overwritten by the script during build time

  // --- Added Ethereum Sepolia Testnet ---
  eth: {
    chainId: '0xaa36a7', //hexadecimal for metamask
    chainIdInt: 11155111,
    chainName: 'Ethereum Mainnet',
    gasFees: 0,
    purchaseToken: 'ETH',
    hasStaking: true,
    nativeFunction: 'buyWithEth',
    multicall: '0xca11bde05977b3631167028862be2a173976ca11',
    presaleAddress: '0x13d35000A4757DAd36A3820c629a7D4bAcFC8c1e',
    usdTAddress: '0x9fa2AE3c0a571BbBFd17E74d7470b6c444A87aF2',
    usdcAddress: '0x232331e4e45582742A2D717562Cd682fA132b799',
    rpcURL: 'https://1rpc.io/sepolia',
    backupRPC: 'https://1rpc.io/sepolia',
    blockExplorerURL: 'https://etherscan.io/tx/',
    chainInfo: {
      method: 'wallet_addEthereumChain',
      params: [
        {
          chainId: '0xaa36a7',
          chainName: 'Ethereum Mainnet',
          nativeCurrency: {
            name: 'ETH',
            symbol: 'ETH',
            decimals: 18,
          },
          rpcUrls: ['https://rpc.ankr.com/eth'],
          blockExplorerUrls: ['https://etherscan.io/'],
        },
      ],
    },
  },

  // --- Added BSC Testnet ---
  bsc: {
    chainId: '0x61', //hexadecimal for metamask
    chainIdInt: 97,
    chainName: 'BSC Mainnet',
    gasFees: 0,
    purchaseToken: 'BNB',
    hasStaking: false,
    nativeFunction: 'buyWithBNB',
    presaleAddress: '0xA6D28026a29D03800769bf0B0835B0DD69058aEC',
    multicall: '0xca11bde05977b3631167028862be2a173976ca11',
    usdTAddress: '0xADFc9B54FB7a1677176A7529F03b91081C91355c',
    usdcAddress: '0xF4053F70d6cC72C0473F2a9E42176DB818D24454',
    rpcURL: 'https://bsc-testnet-rpc.publicnode.com',
    backupRPC: 'https://bsc-testnet-rpc.publicnode.com',
    blockExplorerURL: 'https://bscscan.com/tx/',
    chainInfo: {
      method: 'wallet_addEthereumChain',
      params: [
        {
          chainId: '0x61',
          chainName: 'BSC Mainnet',
          nativeCurrency: {
            name: 'BNB',
            symbol: 'BNB',
            decimals: 18,
          },
          rpcUrls: ['https://bsc-dataseed.binance.org'],
          blockExplorerUrls: ['https://bscscan.com/'],
        },
      ],
    },
  },

  // --- Added Polygon Amoy Testnet ---
  polygon: {
    chainIdInt: 80002, // Polygon Amoy Testnet (Replaced Mumbai)
    chainName: 'Polygon',
    gasFees: 0,
    purchaseToken: "MATIC",
    hasStaking: false,
    nativeFunction: "buyWithMATIC",
    rpcURL: 'https://polygon-amoy.g.alchemy.com/v2/G-_81AUl5fGPs-56wtGsxew9ZczXf-Jm',
    backupRPC: 'https://polygon-amoy.g.alchemy.com/v2/G-_81AUl5fGPs-56wtGsxew9ZczXf-Jm',
    blockExplorerUrl: 'https://amoy.polygonscan.com/',
    multicall: '0xca11bde05977b3631167028862be2a173976ca11',
    presaleAddress: '0xf82C18dFA38fA9bC49D84A283F29A9f3f7C1B28E',
    usdTAddress: '0x2bf4095B666B23B9BBbb4b942fd1Dfa0335254e4',
    usdcAddress: '0xD0d47eC897B739344515bEEBeeDb2365105e9455',
  },

  // --- Added Arbitrum Testnet ---
  arbitrum: {
    chainIdInt: 421614, // Arbitrum Sepolia Testnet (Replaced Goerli)
    chainName: 'Arbitrum Sepolia Testnet',
    nativeFunction: "buyWithEth",
    gasFees: 0,
    rpcURL: 'https://arbitrum-sepolia.gateway.tenderly.co',
    backupRPC: 'https://arbitrum-sepolia.gateway.tenderly.co',
    blockExplorerUrl: 'https://sepolia.arbiscan.io/',
    multicall: '0xca11bde05977b3631167028862be2a173976ca11',
    presaleAddress: '0x3aC2f2ed58353CeDC586E8DFCf8118094a35F834',
    usdTAddress: '0x0479aB1Af7d6095a5b2BE8F4470A7F368f7A7f15',
    usdcAddress: '0x9F5516818e17fa949B2141Eed54dB400dAfCa02f',
    arbAddress: '0x8fAf91b45f7693857dF79aB2afdB53c572Ad2B9C',
    hasStaking: false,
    purchaseToken: 'ARB',
  },

  // --- Added Solana Devnet ---
  sol: {
    chainIdInt: 103,
    usdcTokenAddress: 'DZhmFKmhiahcfd2o2RVE7jNGGrZnL7KNUgEh7huWXE1r', //USDC TOKEN ADDRESS
    usdtTokenAddress: 'usdRjXs6N7e2EHKtinvYQhds2Y4uTpSYrYd5iNAw6Vq', //USDT TOKEN ADDRESS
    presaleAddress: 'GgRBtUHV5CttHXiwsvMwYshAdDLyh2Yu6H9XJUmRA8Gb',
    SolRpcUrl: 'https://api.devnet.solana.com',
    SolBackupRpcUrl: 'https://api.devnet.solana.com',
    otherAccountUsdc: 'A5PXBRWzy3dT3e4y332MnoHSiio7ujpcm9sUALmyttRd', // USDC TOKEN ACCOUNT ADDRESS - USER LEVEL
    otherAccountUsdt: '55yoz1i8ebLVDCwRRM2XusQjP1ZgKpeebvDTsHwypCsu', // USDT TOKEN ACCOUNT ADDRESS - USER LEVEL
    otherAccountSol: '67TyzJqxjKjmCjH3gdABV2TrAuZckLMwh5uXc4RpPjpm', // WALLET ADDRESS
    chainlinkFeed: '99B2bTijsU6f1GCT73HmdR7HCFFjGMBcPZY6jZ96ynrR', // USED TO FETCH SOL CURRENT PRIZE, THIS VARIOUS ACCORDING TO TOKEN
    chainlinkProgram: '7UVimffxr9ow1uXYxsr4LHAcV58mLzhmwaeKvJ1pjLiE', // USED FOR CHAIN LINK FEED, REMAINS SAME FOR ALL TOKENS
    gasFees: 0.0001,
    blockExplorerURL: 'https://solscan.io/tx/',
    purchaseToken: 'SOL',
    nativeFunction: 'buyToken',
    hasStaking: false,
  },

  minToken: 0,
  stakingAddress: '0x634110E48A4219813f24A91A19CD56843D759042',
  apyCalcConst: 400000000,
  stakeUnlockTime: 1912943476000, // add 7 days epoch time in milliseconds with the claim activation time
  robots: 'index, follow',
  tokenName: '$SEERX',
  iidDashFx: 0,
  urlDashFx_aws: '',
  urlDashFx_firebase: '',
  urlDashFx_cloudfront: '',
  wertOrigin: 'https://sandbox.wert.io', // testnet
  partnerId: '01HK57C8XMFEVRTMAW55NBD9W2', // testnet
  wertUrl: 'https://ijs2jkwmnzohnnjppqkypl2avq0hhlcm.lambda-url.eu-west-2.on.aws/', // testnet
  referUrl: 'https://fztdp5he4ueq4nytzyj2ycx7vm0wwqth.lambda-url.eu-west-2.on.aws/',
  bwUniversalLink: 'https://best-wallet-dev.web.app',
  bwDeepLink: 'bw-dev://app/connect?',
  bwApiUrl: 'https://d19yvvzbif6vnj.cloudfront.net/webhook-service-api/presale',
  showBestWallet: false,
  domain: 'https://seerdex.com', // replace with live site URL [NO SLASH IN THE END]
  sseUrl: 'https://dtxw9xix4exl0.cloudfront.net/presale-analytics-service/v1/api/sse-by-slug?slug=SEERX&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzbHVnIjoiU0VFUlgiLCJpYXQiOjE3ODA5ODU5NjF9.PsIfXxkbRdqcEw4hz9OlR-DccJMDljm6RjTbOCcFHoo',
  notificationTimeout: 7000,
  presaleName: 'Seerdex',
  presale_singular_link: 'https://best.sng.link/Dnio2/16gi?_smtype=3',
  post_presale_singular_link: '',
  wertOnRampUrl: 'https://wert-onramp.weathered-tooth-7cf8.workers.dev', // will change according to the presales.
  twitterId: '@ICO_TWIT', // twitter handler id. i.e. '@abc_TWIT',
  reownProductId: '4c9c7ef0bfd4254308c0516f200d0105',
  isVwoEnabled: false,
  isClaimEnabled: false, // need to set it true when claim is live,
  solGasAddress: '4WzwRDFh4JCNcdfYGUdsHche8uYw8T8f55nMTeG6UojU', // SOL GAS WALLET ADDRESS
  wertSigner: 'CYdZAb4i2oaz5CiAvwenMyUVm2DJdd2cWKsekKxxXCQX',
  crmPixelUrl: 'https://d1zf7cen38fcax.cloudfront.net/',
  crmPixelApiKey: '9JIT77Nabj4qvk2aFqvgk1JFmr7GrKUg4wybMLza', //add api key here, will be provided by the crm team, this is a placeholder testing key
  slug: 'SEERX',
  pixelEnv: 'staging',
  crmPixelEventsApiUrl: 'https://d4pkym2fwup68.cloudfront.net/events',
  gasAddress: '0x0000000000000000000000000000000000000001',
  transactionUrl: "https://dtxw9xix4exl0.cloudfront.net/presale-analytics-service/v1/api/transactions/SEERX?count=10&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzbHVnIjoiU0VFUlgiLCJpYXQiOjE3ODA5ODU5NjF9.PsIfXxkbRdqcEw4hz9OlR-DccJMDljm6RjTbOCcFHoo",
  PUBLIC_ETH_ROUTER_ADDRESS_v2: '0xeE567Fe1712Faf6149d80dA1E6934E354124CfE3',
  PUBLIC_ETH_ROUTER_ADDRESS_v3: '0xEd1f6473345F45b75F8179591dd5bA1888cf2FB3',
  PUBLIC_BSC_ROUTER_ADDRESS_v2: '0xD99D1c33F9fC3444f8101754aBC46c52416550D1',
  PUBLIC_BSC_ROUTER_ADDRESS_v3: '0xbC203d7f83677c7ed3F7acEc959963E7F4ECC5C2',
  sendGTAGData: false, // set it false to stop sending data to gtag
};
*/
